import { useState } from 'react'
import { ChallengeModal } from './ChallengeModal'

type ChallengeDetailContentProps = {
    title: string
    distanceUnit: string
    totalDistance: number
    htmlString: string
    hasAccess: boolean
    hasJoined: boolean
}

export const ChallengeDetailContent = ({
    title,
    distanceUnit,
    totalDistance,
    htmlString,
    hasAccess,
    hasJoined
}: ChallengeDetailContentProps) => {
    const [isModalVisible, setIsModalVisible] = useState(false)

    return (
        <>
            <div className="max-w-screen-fullHd mx-auto p-5 sm:p-10 mb-12 relative">
                <p className="font-medium text-2xl md:text-3xl mb-1">{title}</p>
                <p className="text-xl md:text-2xl uppercase font-light text-gray-600 mb-3">
                    {totalDistance} {distanceUnit}
                </p>
                <div className="pb-5 w-full flex">
                    <button
                        onClick={() => setIsModalVisible(true)}
                        className={`py-4  text-white font-medium rounded-xl w-full max-w-[250px] ${
                            hasJoined
                                ? 'bg-gray-500'
                                : hasAccess
                                ? 'bg-yf-green'
                                : 'bg-yf-purple'
                        }`}
                    >
                        {hasJoined
                            ? 'Joined'
                            : hasAccess
                            ? 'Start Challenge'
                            : 'Sign Up to Start Challenge'}
                    </button>
                </div>
                <section>
                    <div
                        className="prose-lg max-w-4xl font-light"
                        dangerouslySetInnerHTML={{ __html: htmlString }}
                    />
                </section>
            </div>
            <ChallengeModal
                hasAccess={hasAccess}
                open={isModalVisible}
                closeModal={() => setIsModalVisible(false)}
            />
        </>
    )
}
